export const updateprofile = (profile) => {
    return {
        type: 'UPDATE_PROFILE',
        payload: profile
    }
}

export const allProducts = (products) => {
    return {
        type: 'ALL_PRODUCTS',
        payload: products
    }
}

export const selectedProduct = (product) => {
    return {
        type: 'SELECTED_PRODUCT',
        payload: product
    }
}
